// TypeScript interfaces generated from Prisma schema

export enum Role {
  USER = "USER",
  ADMIN = "ADMIN",
}

export interface cal_user {
  id: number;
  username: string;
  password: string;
  language: string;
  create_date: Date;
  last_update_date: Date;
  is_deleted: boolean;
  role: Role;
  calPlaces?: cal_place[];
  calRecords?: cal_record[];
  calUserCal?: cal_user_calendar[];
}

export interface cal_calendar {
  id: number;
  name: string;
  create_date_utc: Date;
  color?: string;
  is_deleted: boolean;
  calPlaces?: cal_place[];
  calRecords?: cal_record[];
  calUserCal?: cal_user_calendar[];
}

export interface cal_record {
  id: number;
  name: string;
  start_date: Date;
  end_date: Date;
  description: string;
  create_date_utc: Date;
  user_id: number;
  user: cal_user;
  calendar_id: number;
  calendar: cal_calendar;
  place_id?: number;
  place?: cal_place;
  is_annual_leave: boolean;
  is_deleted: boolean;
}

export interface cal_holiday {
  id: number;
  name: string;
  start_date: Date;
  end_date: Date;
  description: string;
  description_zh: string;
  description_cn: string;
  create_date_utc: Date;
  is_deleted: boolean;
}

export interface cal_place {
  id: number;
  name: string;
  address: string;
  create_date_utc: Date;
  user_id: number;
  user: cal_user;
  calendar_id: number;
  calendar: cal_calendar;
  is_deleted: boolean;
  calRecords?: cal_record[];
}

export interface cal_user_calendar {
  calendar_id: number;
  calendar: cal_calendar;
  defaultShow: boolean;
  user_id: number;
  user: cal_user;
}

export interface cal_cron {
  id: number;
  name: string;
  description: string;
}
